import React, { Component } from 'react'
import $ from 'jquery'
import swal from 'sweetalert2'
import { FormattedMessage } from 'react-intl'
import Config from '../../commons/config/Config.js'
import Security from '../../commons/security/Security.js'
import * as Constants from '../atributoDinamico/constants.js'

// VEC-3599: confirma la validación/rechazo en bloque de varios checklists
// seleccionados desde la grilla (a diferencia de ValidacionGranularModal, que
// decide ítem por ítem dentro de un solo checklist). Aplica la misma decisión
// y el mismo comentario a TODOS los ítems relevantes de cada checklist
// seleccionado, sobrescribiendo cualquier decisión individual previa — ver
// Service/ValidacionGranularService::validarChecklistsEnBloque() y
// docs/vec-3599-validacion-masiva-checklists.md, sección 3 (Q1/Q2/Q3).
class ValidacionMasivaModal extends Component {
	constructor(props) {
		super(props);
		this.modalId = 'modal_validacion_masiva';
		this.concluido = false;
		// El comentario es siempre opcional (validar o rechazar), gestionado con el
		// mismo permiso que el resto del flujo — ver ValidacionGranularModal.
		this.hasPermissionComentar = Security.hasPermission('CHECKLIST_COMENTAR');
		this.state = { motivo: '', submitting: false };
		this.handleCerrar = this.handleCerrar.bind(this);
		this.handleConfirmar = this.handleConfirmar.bind(this);
		this.handleMotivoChange = this.handleMotivoChange.bind(this);
	}

	componentDidMount() {
		let component = this;
		$('#' + this.modalId).modal({ backdrop: 'static' });
		$('#' + this.modalId).on('hidden.bs.modal', function () {
			if (!component.concluido) {
				component.props.onClose();
			}
		});
	}

	componentWillUnmount() {
		$('#' + this.modalId).off('hidden.bs.modal');
	}

	handleCerrar() {
		$('#' + this.modalId).modal('hide');
	}

	handleMotivoChange(e) {
		this.setState({ motivo: e.target.value.slice(0, 240) });
	}

	handleConfirmar() {
		let component = this;
		let intl = this.props.intl;
		let motivo = this.state.motivo.trim();

		this.setState({ submitting: true });

		fetch(Config.get('apiUrlBase') + '/formulario/validar-items-bloque', {
			method: 'POST',
			body: JSON.stringify({
				formulario_ids: this.props.seleccion.map(function (f) { return f.id; }),
				decision: this.props.decision,
				motivo: motivo ? motivo : null,
			}),
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				'Authorization-Token': localStorage.getItem('token'),
			},
		}).then(function (response) {
			if (response.status === 200) {
				response.json().then(function (data) {
					component.concluido = true;
					swal({
						title: intl.formatMessage({ id: 'validacionMasiva.exito_titulo', defaultMessage: 'Validación registrada' }),
						icon: 'success',
					}).then(function () {
						$('#' + component.modalId).modal('hide');
						component.props.onConcluido(data);
					});
				});
			} else {
				response.json().then(function (data) {
					component.setState({ submitting: false });
					swal({
						title: (data && data.error) ? data.error : intl.formatMessage({ id: 'validacionMasiva.error_generico', defaultMessage: 'No se pudo completar la acción.' }),
						icon: 'error',
					});
				}).catch(function () {
					component.setState({ submitting: false });
					swal({ title: intl.formatMessage({ id: 'validacionMasiva.error_generico', defaultMessage: 'No se pudo completar la acción.' }), icon: 'error' });
				});
			}
		}).catch(function () {
			component.setState({ submitting: false });
			swal({ title: intl.formatMessage({ id: 'validacionMasiva.error_generico', defaultMessage: 'No se pudo completar la acción.' }), icon: 'error' });
		});
	}

	render() {
		let intl = this.props.intl;
		let seleccion = this.props.seleccion;
		let esRechazo = this.props.decision === Constants.ID_DECISION_INVALIDO;
		let bases = Array.from(new Set(seleccion.map(function (f) { return f.base; }).filter(Boolean)));
		let plantillas = Array.from(new Set(seleccion.map(function (f) { return f.plantilla; }).filter(Boolean)));
		let hayParciales = seleccion.some(function (f) { return f.tieneValidacionesGranulares; });

		return (
			<div className="modal fade" tabIndex="-1" id={this.modalId} role="dialog" aria-labelledby={this.modalId + '_label'}>
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header bg-fleet">
							<h4 className="modal-title text-white" id={this.modalId + '_label'}>
								<i className="ft-info align-middle icon-modal-title"></i>
								{esRechazo
									? <FormattedMessage id="validacionMasiva.titulo_rechazar" defaultMessage="Confirmar rechazo en bloque" />
									: <FormattedMessage id="validacionMasiva.titulo_validar" defaultMessage="Confirmar validación en bloque" />
								}
							</h4>
						</div>
						<div className="modal-body modal-grey">
							{(bases.length > 1 || plantillas.length > 1) &&
								<div className="alert alert-info">
									<FormattedMessage
										id="validacionMasiva.mezcla_info"
										defaultMessage="La selección combina {bases} base(s) y {plantillas} plantilla(s) distintas. Se va a aplicar la misma decisión y el mismo comentario a todos."
										values={{ bases: bases.length, plantillas: plantillas.length }}
									/>
								</div>
							}
							{hayParciales &&
								<div className="alert alert-warning">
									<FormattedMessage
										id="validacionMasiva.sobreescribe_warning"
										defaultMessage="Uno o más checklists seleccionados ya tienen ítems validados individualmente. Esta acción los va a sobrescribir."
									/>
								</div>
							}
							<p>
								<FormattedMessage
									id="validacionMasiva.resumen"
									defaultMessage="Se van a {accion} todas las respuestas de {cantidad} checklist(s) seleccionados."
									values={{
										accion: esRechazo
											? intl.formatMessage({ id: 'validacionMasiva.accion_rechazar', defaultMessage: 'rechazar' })
											: intl.formatMessage({ id: 'validacionMasiva.accion_validar', defaultMessage: 'validar' }),
										cantidad: seleccion.length,
									}}
								/>
							</p>
							{this.hasPermissionComentar &&
								<div className="form-group">
									<label>
										<FormattedMessage id="validacionMasiva.label_motivo_opcional" defaultMessage="Comentario único para toda la selección (opcional)" />
									</label>
									<textarea
										className="form-control"
										maxLength={240}
										value={this.state.motivo}
										onChange={this.handleMotivoChange}
										placeholder={intl.formatMessage(esRechazo
											? { id: 'validacionMasiva.motivo_placeholder_rechazar', defaultMessage: 'Motivo del rechazo (opcional)...' }
											: { id: 'validacionMasiva.motivo_placeholder_validar', defaultMessage: 'Motivo (opcional)...' }
										)}
									/>
									<small className="text-muted">{this.state.motivo.length} / 240</small>
								</div>
							}
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-secondary" onClick={this.handleCerrar} disabled={this.state.submitting}>
								<FormattedMessage id="validacionMasiva.boton_cancelar" defaultMessage="Cancelar" />
							</button>
							<button
								type="button"
								className={esRechazo ? 'btn btn-danger' : 'btn btn-success'}
								onClick={this.handleConfirmar}
								disabled={this.state.submitting}
							>
								{esRechazo
									? <FormattedMessage id="validacionMasiva.boton_rechazar_bloque" defaultMessage="Rechazar en bloque" />
									: <FormattedMessage id="validacionMasiva.boton_validar_bloque" defaultMessage="Validar en bloque" />
								}
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default ValidacionMasivaModal;
